(function () {
  'use strict';

  // ===== CAROUSELS =====
  function initCarousels() {
    document.querySelectorAll('[data-summer-carousel]').forEach(function (viewport) {
      var track = viewport.querySelector('[data-summer-carousel-track]');
      var prev = viewport.querySelector('[data-summer-carousel-prev]');
      var next = viewport.querySelector('[data-summer-carousel-next]');
      if (!track || !prev || !next) return;
      var step = function (dir) {
        var slide = track.querySelector('li');
        if (!slide) return;
        track.scrollBy({ left: (slide.getBoundingClientRect().width + 24) * dir, behavior: 'smooth' });
      };
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
    });
  }

  // ===== UV INDEX (visitor geolocation) =====
  var UV_CACHE_KEY = 'summer-page-uv';
  var UV_CACHE_TTL_MS = 30 * 60 * 1000;

  function severityFor(uv) {
    if (uv <= 2) return 'low';
    if (uv <= 5) return 'moderate';
    if (uv <= 7) return 'high';
    if (uv <= 10) return 'very_high';
    return 'extreme';
  }

  // Localized copy read from data-attributes on root (set via Liquid | t filter); falls back to English.
  function uvCopy(root, sev) {
    var fallback = {
      low:       { label: 'Low',       advice: 'No protection needed for most people.' },
      moderate:  { label: 'Moderate',  advice: 'Some protection required — wear sunscreen.' },
      high:      { label: 'High',      advice: 'Protection essential — sunscreen, hat, shade.' },
      very_high: { label: 'Very High', advice: 'Extra protection — limit midday exposure.' },
      extreme:   { label: 'Extreme',   advice: 'Avoid sun exposure between 10am and 4pm.' }
    }[sev];
    return {
      label:  root.getAttribute('data-uv-sev-' + sev) || fallback.label,
      advice: root.getAttribute('data-uv-adv-' + sev) || fallback.advice
    };
  }

  function readCache() {
    try {
      var raw = localStorage.getItem(UV_CACHE_KEY);
      if (!raw) return null;
      var p = JSON.parse(raw);
      if (!p || typeof p.t !== 'number' || typeof p.v !== 'number') return null;
      if (Date.now() - p.t > UV_CACHE_TTL_MS) return null;
      return { v: p.v, place: (typeof p.place === 'string' ? p.place : null), precise: !!p.precise };
    } catch (e) { return null; }
  }
  function writeCache(v, place, precise) {
    try { localStorage.setItem(UV_CACHE_KEY, JSON.stringify({ t: Date.now(), v: v, place: place || null, precise: !!precise })); } catch (e) {}
  }

  // Approximate visitor location from IP — no permission prompt (mirrors Ruhl Plage's instant display).
  function fetchIPLocation() {
    return fetch('https://get.geojs.io/v1/ip/geo.json', { cache: 'no-store' }).then(function (res) {
      if (!res.ok) throw new Error('geo ' + res.status);
      return res.json();
    }).then(function (d) {
      var lat = parseFloat(d && d.latitude);
      var lon = parseFloat(d && d.longitude);
      if (isNaN(lat) || isNaN(lon)) throw new Error('geo: no coords');
      var place = (d && (d.city || d.region || d.country)) || null;
      return { lat: lat, lon: lon, place: place };
    });
  }

  // Precise device location (GPS/Wi-Fi) — accurate but shows the browser permission prompt.
  function fetchPreciseLocation() {
    return new Promise(function (resolve, reject) {
      if (!navigator.geolocation) { reject(new Error('geolocation unsupported')); return; }
      navigator.geolocation.getCurrentPosition(
        function (pos) { resolve({ lat: pos.coords.latitude, lon: pos.coords.longitude }); },
        function (err) { reject(err); },
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 5 * 60 * 1000 }
      );
    });
  }

  // Best-effort city name for precise coords (open-meteo returns no place name). Never rejects.
  function reverseGeocode(lat, lon) {
    var lang = (document.documentElement.lang || 'en').slice(0, 2);
    var url = 'https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=' + lat +
              '&longitude=' + lon + '&localityLanguage=' + lang;
    return fetch(url, { cache: 'no-store' })
      .then(function (res) { if (!res.ok) throw new Error('revgeo ' + res.status); return res.json(); })
      .then(function (d) { return (d && (d.city || d.locality || d.principalSubdivision)) || null; })
      .catch(function () { return null; });
  }

  function fetchUVFor(lat, lon) {
    var url = 'https://api.open-meteo.com/v1/forecast?latitude=' + lat + '&longitude=' + lon + '&current=uv_index&timezone=auto';
    return fetch(url, { cache: 'no-store' }).then(function (res) {
      if (!res.ok) throw new Error('UV API ' + res.status);
      return res.json();
    }).then(function (data) {
      var raw = data && data.current && typeof data.current.uv_index === 'number' ? data.current.uv_index : null;
      if (raw === null) throw new Error('UV API: missing field');
      var v = Math.max(0, Math.min(11, Math.round(raw)));
      return v;
    });
  }

  function renderUV(root, value, place, isPrecise) {
    var live = root.querySelector('[data-summer-uv-live]');
    var valueEl = root.querySelector('[data-summer-uv-value]');
    var sevEl = root.querySelector('[data-summer-uv-severity]');
    var adviceEl = root.querySelector('[data-summer-uv-advice]');
    var locating = root.querySelector('[data-summer-uv-locating]');
    var scaleItems = root.querySelectorAll('[data-summer-uv-scale] [data-uv]');
    var sev = severityFor(value);
    var copy = uvCopy(root, sev);
    valueEl.textContent = value >= 11 ? '11+' : String(value);
    sevEl.textContent = copy.label;
    sevEl.setAttribute('data-severity', sev);
    adviceEl.textContent = copy.advice;
    var whereEl = root.querySelector('[data-summer-uv-where]');
    if (whereEl) {
      var tmpl = root.getAttribute('data-uv-where') || '';
      var fb = root.getAttribute('data-uv-where-fallback') || '';
      whereEl.textContent = tmpl ? tmpl.replace('{place}', place || fb) : '';
    }
    Array.prototype.forEach.call(scaleItems, function (item) {
      item.classList.toggle('is-active', Number(item.getAttribute('data-uv')) === Math.min(value, 11));
    });
    if (locating) locating.hidden = true;
    live.hidden = false;
    // Once we have a precise (device) reading, the opt-in button has done its job.
    var btn = root.querySelector('[data-summer-uv-precise]');
    var errEl = root.querySelector('[data-summer-uv-precise-error]');
    if (btn) { btn.disabled = false; if (isPrecise) btn.hidden = true; }
    if (errEl && isPrecise) errEl.hidden = true;
    if (isPrecise) root._uvPrecise = true; // mark so the async IP path can't overwrite it
  }

  function showFallback(root) {
    var locating = root.querySelector('[data-summer-uv-locating]');
    var cta = root.querySelector('[data-summer-uv-fallback-cta]');
    if (locating) locating.hidden = true;
    if (cta) cta.hidden = false;
  }

  // Refine the reading with the device's precise location (asks permission).
  function runPrecise(root) {
    var btn = root.querySelector('[data-summer-uv-precise]');
    var errEl = root.querySelector('[data-summer-uv-precise-error]');
    var locating = root.querySelector('[data-summer-uv-locating]');
    if (errEl) errEl.hidden = true;
    if (btn) btn.disabled = true;
    if (locating) locating.hidden = false;
    fetchPreciseLocation()
      .then(function (loc) {
        return reverseGeocode(loc.lat, loc.lon).then(function (place) {
          return fetchUVFor(loc.lat.toFixed(3), loc.lon.toFixed(3)).then(function (v) {
            writeCache(v, place, true);
            renderUV(root, v, place, true);
          });
        });
      })
      .catch(function (err) {
        console.warn('[summer-page] precise UV unavailable:', err);
        if (locating) locating.hidden = true;
        if (btn) btn.disabled = false;
        if (errEl) { errEl.textContent = root.getAttribute('data-uv-precise-error') || ''; errEl.hidden = false; }
      });
  }

  // Only phones/tablets have real GPS. On desktop the Geolocation API falls back to
  // Wi-Fi/IP (same Paris guess as our IP lookup), so the "precise" button is misleading
  // there — restrict it to mobile devices.
  function isMobileDevice() {
    if (navigator.userAgentData && typeof navigator.userAgentData.mobile === 'boolean') {
      return navigator.userAgentData.mobile;
    }
    return /Android|iPhone|iPod|iPad|Windows Phone|IEMobile|BlackBerry|Opera Mini|Mobile/i.test(navigator.userAgent || '');
  }

  // Wire the opt-in button; auto-refine (no prompt) if permission was already granted.
  function setupPrecise(root) {
    if (!navigator.geolocation) return;
    if (!isMobileDevice()) return; // desktop: keep the instant IP value, hide the button
    var btn = root.querySelector('[data-summer-uv-precise]');
    if (!btn) return;
    btn.addEventListener('click', function () { runPrecise(root); });
    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: 'geolocation' }).then(function (status) {
        if (status.state === 'granted') { runPrecise(root); }      // already allowed → no prompt
        else if (status.state === 'prompt') { btn.hidden = false; } // let the visitor opt in
        // 'denied' → leave the button hidden
      }).catch(function () { btn.hidden = false; });
    } else {
      btn.hidden = false;
    }
  }

  function initUV() {
    var root = document.querySelector('[data-summer-uv]');
    if (!root) return;
    var cached = readCache();
    if (cached !== null) {
      renderUV(root, cached.v, cached.place, cached.precise);
      if (!cached.precise) setupPrecise(root); // still let them sharpen a cached IP reading
      return;
    }
    setupPrecise(root);
    var locating = root.querySelector('[data-summer-uv-locating]');
    if (locating) locating.hidden = false;
    // Resolve approximate location from IP (no prompt), then fetch the UV index for it.
    fetchIPLocation()
      .then(function (loc) {
        return fetchUVFor(loc.lat.toFixed(3), loc.lon.toFixed(3)).then(function (v) {
          if (root._uvPrecise) return; // a precise reading already won — don't clobber it
          writeCache(v, loc.place, false);
          renderUV(root, v, loc.place, false);
        });
      })
      .catch(function (err) { console.warn('[summer-page] UV unavailable:', err); showFallback(root); });
  }

  // ===== FADE-UP ON SCROLL =====
  function initFadeUp() {
    var els = document.querySelectorAll('[data-fade-up]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('is-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); obs.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    Array.prototype.forEach.call(els, function (el) { obs.observe(el); });
  }

  // Each init is isolated: a throw in one must not stop the others. initFadeUp
  // runs last, so before this an early failure left every [data-fade-up] hidden.
  function run(name, fn) {
    try { fn(); } catch (e) { console.error('[summer-page] ' + name + ' failed:', e); }
  }
  function init() {
    run('initCarousels', initCarousels);
    run('initUV', initUV);
    run('initFadeUp', initFadeUp);
  }

  // Opt into the hidden state only now that the script is running. If this file
  // never loads or throws before this line, the CSS leaves the content visible.
  document.documentElement.classList.add('js-fade-ready');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
